<template>
  <v-container fluid class="theme-color" style="height: 100%; overflow-x:scroll;">
    <RoadReport />
  </v-container>
</template>

<script>
import RoadReport from '../components/road-executive/RoadReport.vue';

export default {
  name: 'RoadExecutive',
  components: {
    RoadReport
  },
  data: () => ({}),
  mounted() {
    this.$emit('gobacktolink', 'report-executive');
  },
  methods: {}
};
</script>
